import { useIsMutating } from "react-query"

import { QueryKey } from "@libs/constants/queryKey"

/**
 * Indica si el flujo de cotización tiene alguna mutation en vuelo.
 *
 * @returns `true` mientras alguna llamada del flujo siga pendiente — el
 *   modal de carga espera a TODAS, no solo a la primera.
 */
export const useIsCotizationFlowPending = (): boolean => {
  return useIsMutating([QueryKey.COTIZATION_FLOW]) > 0
}
